import * as React from 'react';

function SvgCallReceived(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			height='1em'
			viewBox='0 0 24 24'
			width='1em'
			className='svg-icon'
			{...props}>
			<path d='M0 0h24v24H0V0z' fill='none' />
			<path d='M15 17H8.41L20 5.41 18.59 4 7 15.59V9H5v10h10z' />
		</svg>
	);
}

export default SvgCallReceived;
